import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_COPAY_INFO_REQUEST: '',
  GET_COPAY_INFO_SUCCESS: '',
  GET_COPAY_INFO_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityCopay');

export default types;
